function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.3716 15.0686H16.5791C15.9052 15.0686 14.7803 15.324 14.7803 17.0576V19.7096H32.1704V17.0576C32.1704 15.3295 31.0455 15.0686 30.3716 15.0686Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.0308 20.2853H8.406V11.0142H6.66699V28.9858H8.406V24.3448H31.5946V28.9803H33.3337V20.2853H11.0308Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3022 19.8181C12.6438 19.8181 13.7314 18.7305 13.7314 17.3889C13.7314 16.0473 12.6438 14.9597 11.3022 14.9597C9.96063 14.9597 8.87305 16.0473 8.87305 17.3889C8.87305 18.7305 9.96063 19.8181 11.3022 19.8181Z",
  fill: "#D7D6E0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26.6667,
  height: 26.6667,
  fill: "white",
  transform: "translate(6.66699 6.66675)"
})));

var SvgBed = function SvgBed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bed.bb03a58a.svg";
export { ForwardRef as ReactComponent };